module.exports = __webpack_public_path__ + "img/share-icon-new.8f1e58a7.svg";